
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import QUALIFIEDCOUNT from "../../assets/documents/QUALIFIED_COUNT_TABLE__ALL_POST_.pdf";
import Archaeologgymarathi from "../../assets/documents/Archaeologgy__Photographar__IH_Marathi_2024__1_.pdf";
import Archaeologgyenglish from "../../assets/documents/Archaeologgy__Photographar__IH_Eng_2024__1_.pdf";
import Archaeologgymarathi1 from "../../assets/documents/Archaeologgy__Various_posts__IH_Marathi_2023.pdf";

import selectionLists1 from "../../assets/documents/Provisional_selection_list_of_Conservation_Overseer_for_OBC__General__againt_OBC__Ex-Servicemen___Dat.pdf";
import selectionLists2 from "../../assets/documents/Provisionsal_Selection_list_of_Conservation_Overseer_for_EWS__General__Against_EWS__Women___Date.17.0.pdf";
import selectionLists3 from "../../assets/documents/Revised_selection_list_of_Conservation_Overseer_for_OBC__General__Category__Date.17.07.2025.pdf";
import selectionLists4 from "../../assets/documents/Provisional_selection_list_against_OBC__EX-Servicemen__of_Assistant_Archaeologist.pdf";
import selectionLists5 from "../../assets/documents/Department of Tourism and Cultural Affairs.pdf";
import selectionLists6 from "../../assets/documents/Revised_Selection_list_of_Conservation_Overseer-Date.05.12.2024.pdf";
import selectionLists7 from "../../assets/documents/Conservation Assistant Engineer.pdf";
import selectionLists8 from "../../assets/documents/Conservation Overseer.pdf";
import selectionLists9 from "../../assets/documents/Assistant Archaeologist.pdf";
import selectionLists10 from "../../assets/documents/MERIT PRT - Photographer.pdf";
import selectionLists11 from "../../assets/documents/MERIT_PRT-Assistant_Photographer.pdf";
import selectionLists12 from "../../assets/documents/Assistant Research Officer - Selection List and Waiting List.pdf";
import selectionLists13 from "../../assets/documents/Farshijnaat Sankalak - Selection List and Waiting List.pdf";
import selectionLists14 from "../../assets/documents/Library and Clerk - Selection List and Waiting List.pdf";
import selectionLists15 from "../../assets/documents/Chemist - Selection List and Waiting List.pdf";
import selectionLists16 from "../../assets/documents/Archivist Group-B - Selection List.pdf";
import selectionLists17 from "../../assets/documents/Conservation Junior Engineer Group-C - Selection List.pdf";
import selectionLists18 from "../../assets/documents/Compiler Group-C - Selection List.pdf";
import selectionLists19 from "../../assets/documents/Research Assistant Group-C - Selection List.pdf";
import selectionLists20 from "../../assets/documents/Selection List - Superintendent Group-B (Non-Gazetted).pdf";
import selectionLists21 from "../../assets/documents/Selection List - Record Attendant Group-C.pdf";
import selectionLists22 from "../../assets/documents/Selection List - Note Assistant Group-C.pdf";
import selectionLists23 from "../../assets/documents/Selection List - Technician Assistant Group-C.pdf";
import selectionLists24 from "../../assets/documents/Selection List - Guide Lecturer Group-C.pdf";
import selectionLists25 from "../../assets/documents/Selection List - Assistant Superintendent Group-C.pdf";
import selectionLists26 from "../../assets/documents/Selection List - Assistant Group-C.pdf";

import marksLists1 from "../../assets/documents/Assistant__Gazetteer_Department__BSL.pdf";
import marksLists2 from "../../assets/documents/Assistant_archaeologist_BSL.pdf";
import marksLists3 from "../../assets/documents/Conservation_assistant_engineer_BSL.pdf";
import marksLists4 from "../../assets/documents/Conservation_overseer_BSL.pdf";
import marksLists5 from "../../assets/documents/BSL-Assistant_Photographer.pdf";
import marksLists6 from "../../assets/documents/BSL-Photographer.pdf";
import marksLists7 from "../../assets/documents/Merit List - Library Clerk and Storekeeper.pdf";
import marksLists8 from "../../assets/documents/Merit List - Farshijnaat Sankalak.pdf";
import marksLists9 from "../../assets/documents/Merit List - Chemist.pdf";
import marksLists10 from "../../assets/documents/Merit List - Assistant Research Officer.pdf";
import marksLists11 from "../../assets/documents/Archivist Group-B - Merit List.pdf";
import marksLists12 from "../../assets/documents/Conservation Junior Engineer Group-C - Merit List.pdf";
import marksLists13 from "../../assets/documents/Compiler Group-C - Merit List.pdf";
import marksLists14 from "../../assets/documents/Research Assistant Group-C - Merit List.pdf";
import marksLists15 from "../../assets/documents/Press_Note_of_Mark_list-30.01.2024__3_.pdf";
import marksLists16 from "../../assets/documents/BSL_Asist_30.01.2024.pdf";
import marksLists17 from "../../assets/documents/BSL_Ass_Supt-30.01.2024.pdf";
import marksLists18 from "../../assets/documents/BSL_Musm_Guid_30.01.2024.pdf";
import marksLists19 from "../../assets/documents/BSL_Not_Ass_30.01.2024.pdf";
import marksLists20 from "../../assets/documents/BSL_Rec_Att_30.01.2024.pdf";
import marksLists21 from "../../assets/documents/BSL_Suprt_30.01.2024.pdf";
import marksLists22 from "../../assets/documents/BSL_Tec_Hel_30.01.2024.pdf";

import advertisement1 from "../../assets/documents/Assistant_Darshanika_Result_Press_Note.pdf";
import advertisement2 from "../../assets/documents/Conservation_Overseer_Press_Note_05.12.2024.pdf";
import advertisement3 from "../../assets/documents/Document_Verification_11.10.2024.pdf";
import advertisement4 from "../../assets/documents/Recruitment_Result_Press_Note.pdf";
import advertisement5 from "../../assets/documents/Photographer_Result_Press_Note_13.09.2024.pdf";
import advertisement6 from "../../assets/documents/Photographer_Assistant_Photographer_Press_Note.pdf";
import advertisement7 from "../../assets/documents/Document_Verification_29.07.2024.pdf";
import advertisement8 from "../../assets/documents/Document_Verification_18.07.2024.pdf";
import advertisement9 from "../../assets/documents/Press_Note_12.07.2024_Result_24.05.2024.pdf";
import advertisement10 from "../../assets/documents/QUALIFIED_COUNT_TABLE_OF_DATED_24.05.2024_EXAM.pdf";
import advertisement11 from "../../assets/documents/Press_Note_24.02.2024_Exam_Result.pdf";
import advertisement12 from "../../assets/documents/QUALIFIED_COUNT_TABLE_sub_overseear.pdf";
import advertisement13 from "../../assets/documents/Press_Note_24.05.2024_Admit_Card.pdf";
import advertisement14 from "../../assets/documents/Press_Note_07.05.2024.pdf";
import advertisement15 from "../../assets/documents/Press_Note_Group_B_Group_C_Recruitment_2023.pdf";
import advertisement16 from "../../assets/documents/Online_Applications_Post_Category_15.08.2023.pdf";
import advertisement17 from "../../assets/documents/Press_Note_13.02_24.02.2024_Exam.pdf";
import advertisement18 from "../../assets/documents/Circular_Document_Verification_05.02.2024.pdf";
import advertisement19 from "../../assets/documents/Circular_Post_Increase_05.02.2024.pdf";
import advertisement20 from "../../assets/documents/Press_Note_19.01.2024.pdf";
import advertisement21 from "../../assets/documents/Applications_Details_30.12.2023.pdf";
import advertisement22 from "../../assets/documents/Posts_Session_Wise_List.pdf";
import advertisement23 from "../../assets/documents/Press_Note_18.12.2023.pdf";
import advertisement24 from "../../assets/documents/Corrigendum_Exam_Postponed.pdf";
import advertisement25 from "../../assets/documents/Press_Note.pdf";
import advertisement26 from "../../assets/documents/Advertisement_Final_Draft_14.08.2023.pdf";
import { FaFilePdf } from "react-icons/fa";

const Recruitment = () => {
    const selectedLang = useSelector((state) => state.language.selectedLang);
    const [openDownload, setOpenDownload] = useState(null);


    const informationBooklets = [
        {
            english:
                "Archaeology (Photographer) Information Handout - Marathi 2024",
            marathi:
                "पुरातत्त्वशास्त्र (छायाचित्रकार) माहिती पुस्तिका - मराठी २०२४",
            pdf: Archaeologgymarathi
        },
        {
            english:
                "Archaeology (Photographer) Information Handout - English 2024",
            marathi:
                "पुरातत्त्वशास्त्र (छायाचित्रकार) माहिती पुस्तिका - इंग्रजी २०२४",
            pdf: Archaeologgyenglish
        },
        {
            english: "Information Handout - English 2024",
            marathi: "माहिती पुस्तिका - इंग्रजी २०२४",
            pdf: Archaeologgyenglish
        },
        {
            english: "Information Handout - Marathi 2024",
            marathi: "माहिती पुस्तिका - मराठी २०२४",
            pdf: Archaeologgymarathi
        },
        {
            english: "Qualified Count Table (All Post)",
            marathi: "सर्व पदांसाठी पात्र उमेदवारांची संख्या तक्ता",
            pdf: QUALIFIEDCOUNT
        },
        {
            english:
                "Information Booklet for Examination held on 24/02/2024 - Marathi",
            marathi:
                "दिनांक २४/०२/२०२४ रोजीच्या परीक्षेची माहिती पुस्तिका - मराठी",
            pdf: Archaeologgymarathi
        },
        {
            english:
                "Information Booklet for Examination held on 24/02/2024 - English",
            marathi:
                "दिनांक २४/०२/२०२४ रोजीच्या परीक्षेची माहिती पुस्तिका - इंग्रजी",
            pdf: Archaeologgyenglish
        },
        {
            english: "Information Booklet for Examination - Marathi 2023",
            marathi: "परीक्षेसाठी माहिती पुस्तिका - मराठी २०२३",
            pdf: Archaeologgymarathi1
        },
        {
            english: "Information Booklet for Examination - English 2023",
            marathi: "परीक्षेसाठी माहिती पुस्तिका - इंग्रजी २०२३",
            pdf: Archaeologgyenglish
        },
    ];

    const selectionLists = [
        {
            english:
                "Provisional Selection List of Conservation Overseer for OBC (General) against OBC (Ex-Servicemen), Date",
            marathi:
                "जतन आवेक्षक पदाची OBC (सर्वसाधारण) प्रवर्गासाठी OBC (माजी सैनिक) विरुद्ध तात्पुरती निवड यादी",
            pdf: selectionLists1
        },
        {
            english:
                "Provisional Selection List of Conservation Overseer for EWS (General) against EWS (Women), Date 17.0",
            marathi:
                "जतन आवेक्षक पदाची EWS (सर्वसाधारण) प्रवर्गासाठी EWS (महिला) विरुद्ध तात्पुरती निवड यादी, दिनांक १७.०",
            pdf: selectionLists2
        },
        {
            english:
                "Revised Selection List of Conservation Overseer for OBC (General) Category, Date 17.07.2025",
            marathi:
                "जतन आवेक्षक OBC (सर्वसाधारण) प्रवर्गाची सुधारित निवड यादी, दिनांक १७.०७.२०२५",
            pdf: selectionLists3
        },
        {
            english:
                "Provisional Selection List against OBC (Ex-Servicemen) of Assistant Archaeologist",
            marathi:
                "सहाय्यक पुरातत्त्वज्ञ पदाची OBC (माजी सैनिक) विरुद्ध तात्पुरती निवड यादी",
            pdf: selectionLists4
        },
        {
            english: "Selection List - Assistant (Darshanika Department)",
            marathi: "सहाय्यक (दर्शनिका विभाग) निवड यादी",
            pdf: selectionLists5
        },
        {
            english: "Revised Selection List of Conservation Overseer - Date 05.12.2024",
            marathi: "जतन आवेक्षक सुधारित निवड यादी - दिनांक ०५.१२.२०२४",
            pdf: selectionLists6
        },
        {
            english: "Conservation Assistant Engineer",
            marathi: "जतन सहाय्यक अभियंता",
            pdf: selectionLists7
        },
        {
            english: "Conservation Overseer",
            marathi: "जतन आवेक्षक",
            pdf: selectionLists8
        },
        {
            english: "Assistant Archaeologist",
            marathi: "पुरातत्त्व सहाय्यक",
            pdf: selectionLists9
        },
        {
            english: "MERIT PRT - Photographer",
            marathi: "गुणवत्ता यादी - छायाचित्रकार",
            pdf: selectionLists10
        },
        {
            english: "MERIT PRT - Assistant Photographer",
            marathi: "गुणवत्ता यादी - सहाय्यक छायाचित्रकार",
            pdf: selectionLists11
        },
        {
            english: "Assistant Research Officer - Selection List and Waiting List",
            marathi: "सहाय्यक संशोधन अधिकारी - निवड यादी व प्रतीक्षा सूची",
            pdf: selectionLists12
        },
        {
            english: "Farshijnaat Sankalak - Selection List and Waiting List",
            marathi: "फार्शीज्ञात संकलक - निवड यादी व प्रतीक्षा सूची",
            pdf: selectionLists13
        },
        {
            english: "Library and Clerk - Selection List and Waiting List",
            marathi: "ग्रंथालय नि लिपिक - निवड यादी व प्रतीक्षा सूची",
            pdf: selectionLists14
        },
        {
            english: "Chemist - Selection List and Waiting List",
            marathi: "रसायनशास्त्रज्ञ - निवड यादी व प्रतीक्षा सूची",
            pdf: selectionLists15
        },
        {
            english: "Archivist Group-B - Selection List",
            marathi: "अभिलेखाधिकारी गट-ब निवड यादी",
            pdf: selectionLists16
        },
        {
            english: "Conservation Junior Engineer Group-C - Selection List",
            marathi: "जतन कनिष्ठ अभियंता गट-क निवड यादी",
            pdf: selectionLists17
        },
        {
            english: "Compiler Group-C - Selection List",
            marathi: "संकलक गट-क निवड यादी",
            pdf: selectionLists18
        },
        {
            english: "Research Assistant Group-C - Selection List",
            marathi: "संशोधन सहायक गट-क निवड यादी",
            pdf: selectionLists19
        },
        {
            english: "Selection List - Superintendent Group-B (Non-Gazetted)",
            marathi: "निवड यादी - अधिक्षक गट-ब (अराजपत्रित)",
            pdf: selectionLists20
        },
        {
            english: "Selection List - Record Attendant Group-C",
            marathi: "निवड यादी - अभिलेख परिचर गट-क",
            pdf: selectionLists21
        },
        {
            english: "Selection List - Note Assistant Group-C",
            marathi: "निवड यादी - टिप्पणी सहायक गट-क",
            pdf: selectionLists22
        },
        {
            english: "Selection List - Technician Assistant Group-C",
            marathi: "निवड यादी - तंत्रज्ञ मदतनीस गट-क",
            pdf: selectionLists23
        },
        {
            english: "Selection List - Guide Lecturer Group-C",
            marathi: "निवड यादी - मार्गदर्शक व्याख्याता गट-क",
            pdf: selectionLists24
        },
        {
            english: "Selection List - Assistant Superintendent Group-C",
            marathi: "निवड यादी - सहाय्यक अधिक्षक गट-क",
            pdf: selectionLists25
        },
        {
            english: "Selection List - Assistant Group-C",
            marathi: "निवड यादी - सहाय्यक गट-क",
            pdf: selectionLists26
        },
    ];

    const marksLists = [
        {
            english: "Assistant (Gazetteer Department) BSL",
            marathi: "सहायक (दर्शनिका विभाग) गुणवत्ता यादी",
            pdf: marksLists1
        },
        {
            english: "Assistant Archaeologist BSL",
            marathi: "पुरातत्त्व सहाय्यक गुणवत्ता यादी",
            pdf: marksLists2
        },
        {
            english: "Conservation Assistant Engineer BSL",
            marathi: "जतन सहाय्यक अभियंता गुणवत्ता यादी",
            pdf: marksLists3
        },
        {
            english: "Conservation Overseer BSL",
            marathi: "जतन आवेक्षक गुणवत्ता यादी",
            pdf: marksLists4
        },
        {
            english: "BSL - Assistant Photographer",
            marathi: "गुणांकन यादी - सहाय्यक छायाचित्रकार",
            pdf: marksLists5
        },
        {
            english: "BSL - Photographer",
            marathi: "गुणांकन यादी - छायाचित्रकार",
            pdf: marksLists6
        },
        {
            english: "Merit List - Library Clerk and Storekeeper",
            marathi: "गुणवत्ता यादी - ग्रंथालय लिपिक नि भंडारपाल",
            pdf: marksLists7
        },
        {
            english: "Merit List - Farshijnaat Sankalak",
            marathi: "गुणवत्ता यादी - फार्शीज्ञात संकलक",
            pdf: marksLists8
        },
        {
            english: "Merit List - Chemist",
            marathi: "गुणवत्ता यादी - रसायनशास्त्रज्ञ",
            pdf: marksLists9
        },
        {
            english: "Merit List - Assistant Research Officer",
            marathi: "गुणवत्ता यादी - सहाय्यक संशोधन अधिकारी",
            pdf: marksLists10
        },
        {
            english: "Archivist Group-B - Merit List",
            marathi: "अभिलेखाधिकारी गट-ब गुणवत्ता यादी",
            pdf: marksLists11
        },
        {
            english: "Conservation Junior Engineer Group-C - Merit List",
            marathi: "जतन कनिष्ठ अभियंता गट-क गुणवत्ता यादी",
            pdf: marksLists12
        },
        {
            english: "Compiler Group-C - Merit List",
            marathi: "संकलक गट-क गुणवत्ता यादी",
            pdf: marksLists13
        },
        {
            english: "Research Assistant Group-C - Merit List",
            marathi: "संशोधन सहायक गट-क गुणवत्ता यादी",
            pdf: marksLists14
        },
        {
            english: "Press Note of Mark List - 30.01.2024",
            marathi: "गुणांकन यादी प्रसिद्धीपत्रक - ३०.०१.२०२४",
            pdf: marksLists15
        },
        {
            english: "Assistant Group-C - 30.01.2024",
            marathi: "सहायक गट-क - ३०.०१.२०२४",
            pdf: marksLists16
        },
        {
            english: "Assistant Superintendent Group-C - 30.01.2024",
            marathi: "सहाय्यक अधीक्षक गट-क - ३०.०१.२०२४",
            pdf: marksLists17
        },
        {
            english: "Guide Lecturer Group-C - 30.01.2024",
            marathi: "मार्गदर्शक व्याख्याता गट-क - ३०.०१.२०२४",
            pdf: marksLists18
        },
        {
            english: "Note Assistant Group-C - 30.01.2024",
            marathi: "टिप्पणी सहायक गट-क - ३०.०१.२०२४",
            pdf: marksLists19
        },
        {
            english: "Record Attendant Group-C - 30.01.2024",
            marathi: "अभिलेख परिचर गट-क - ३०.०१.२०२४",
            pdf: marksLists20
        },
        {
            english: "Assistant Superintendent Group-C - 30.01.2024",
            marathi: "सहाय्यक अधीक्षक गट-क - ३०.०१.२०२४",
            pdf: marksLists21
        },
        {
            english: "Technician Assistant Group-C - 30.01.2024",
            marathi: "तंत्रज्ञ मदतनीस गट-क - ३०.०१.२०२४",
            pdf: marksLists22
        },
    ];

    const advertisementLists = [
        {
            english: "Assistant (Gazetteer Department) Result Press Note",
            marathi: "सहाय्यक (दर्शनिका विभाग) निकाल प्रसिद्धीपत्रक",
            pdf: advertisement1
        },
        {
            english: "Conservation Overseer Press Note - Date 05.12.2024",
            marathi: "जतन आवेक्षक प्रसिद्धीपत्रक - दिनांक ०५.१२.२०२४",
            pdf: advertisement2
        },
        {
            english: "Document Verification - Date 11.10.2024",
            marathi: "कागदपत्र पडताळणी दिनांक - ११.१०.२०२४",
            pdf: advertisement3
        },
        {
            english: "Recruitment Result Press Note",
            marathi: "निकाल पदभरती प्रसिद्धीपत्रक",
            pdf: advertisement4
        },
        {
            english: "Photographer Result Press Note - 13.09.2024",
            marathi: "प्रसिद्धीपत्रक - छायाचित्रकार निकाल १३.०९.२०२४",
            pdf: advertisement5
        },
        {
            english: "Photographer and Assistant Photographer Press Note",
            marathi: "फोटोग्राफर व सहाय्यक फोटोग्राफर प्रसिद्धीपत्रक",
            pdf: advertisement6
        },
        {
            english: "Document Verification - Date 29.07.2024",
            marathi: "कागदपत्र पडताळणी दिनांक - २९.०७.२०२४",
            pdf: advertisement7
        },
        {
            english: "Document Verification - Date 18.07.2024",
            marathi: "कागदपत्र पडताळणी दिनांक - १८.०७.२०२४",
            pdf: advertisement8
        },
        {
            english: "Press Note - 12.07.2024 - Result of 24.05.2024 Exam",
            marathi: "प्रसिद्धीपत्रक - १२.०७.२०२४ - दि. २४.०५.२०२४ चा निकाल",
            pdf: advertisement9
        },
        {
            english: "Qualified Count Table of Dated 24.05.2024 Exam",
            marathi: "दिनांक २४.०५.२०२४ च्या परीक्षेचा पात्र उमेदवार संख्या तक्ता",
            pdf: advertisement10
        },
        {
            english: "Press Note - Result of 24.02.2024 Exam",
            marathi: "प्रसिद्धीपत्रक - दिनांक २४.०२.२०२४ च्या परीक्षेचे निकाल",
            pdf: advertisement11
        },
        {
            english: "Qualified Count Table - Conservation Overseer",
            marathi: "जतन आवेक्षक पदासाठी पात्र उमेदवार संख्या तक्ता",
            pdf: advertisement12
        },
        {
            english: "Press Note - Admit Card for 24.05.2024 Exam",
            marathi: "प्रसिद्धीपत्रक - दिनांक २४.०५.२०२४ च्या परीक्षेचे प्रवेशपत्र",
            pdf: advertisement13
        },
        {
            english: "Press Note - 07.05.2024",
            marathi: "प्रसिद्धीपत्रक - ०७.०५.२०२४",
            pdf: advertisement14
        },
        {
            english: "Group-B (Non-Gazetted) and Group-C Recruitment - 2023",
            marathi: "प्रसिद्धीपत्रक - गट-ब (अराजपत्रित) आणि गट-क संवर्गातील पद भरती - २०२३",
            pdf: advertisement15
        },
        {
            english: "Post and Category-wise Number of Online Applications Received for Various Offices",
            marathi: "सांस्कृतिक कार्य विभागाच्या विविध कार्यालयातील रिक्त पदांसाठी प्राप्त ऑनलाईन अर्जांची पद व प्रवर्गनिहाय संख्या",
            pdf: advertisement16
        },
        {
            english: "Press Note - 13.02 - Regarding 24.02.2024 Exam",
            marathi: "प्रसिद्धीपत्रक - १३.०२ - दिनांक २४.०२.२०२४ च्या परीक्षेसंबंधी",
            pdf: advertisement17
        },
        {
            english: "Circular - Document Verification - 05.02.2024",
            marathi: "परिपत्रक - कागदपत्र पडताळणी - ०५.०२.२०२४",
            pdf: advertisement18
        },
        {
            english: "Circular - Post Increase - 05.02.2024",
            marathi: "परिपत्रक - पदसंख्या वाढ - ०५.०२.२०२४",
            pdf: advertisement19
        },
        {
            english: "Press Note - 19.01.2024",
            marathi: "प्रसिद्धीपत्रक - दिनांक १९.०१.२०२४",
            pdf: advertisement20
        },
        {
            english: "Category-wise Application Details of Posts Examined on 30.12.2023",
            marathi: "दिनांक ३०.१२.२०२३ रोजी परीक्षा झालेल्या पदांचे प्रवर्गनिहाय प्राप्त अर्जाचा तपशील",
            pdf: advertisement21
        },
        {
            english: "Post-wise Session List for Examination",
            marathi: "परीक्षेसाठी पदांची सत्रनिहाय यादी",
            pdf: advertisement22
        },
        {
            english: "Press Note - 18.12.2023",
            marathi: "प्रसिद्धीपत्रक - दिनांक १८.१२.२०२३",
            pdf: advertisement23
        },
        {
            english: "Corrigendum - Examination Postponed",
            marathi: "शुद्धीपत्रक - परीक्षा स्थगित",
            pdf: advertisement24
        },
        {
            english: "Press Note",
            marathi: "प्रसिद्धीपत्रक",
            pdf: advertisement25
        },
        {
            english: "Recruitment 2023",
            marathi: "पद भरती २०२३",
            pdf: advertisement26
        }
    ];

    const content = {
        English: {
            title: "Recruitment",
            breadcrumb: {
                home: "HOME",
                page: "Recruitment",
            },

            paragraph:
                "Notice Regarding Cancellation of the Guide Lecturer Post",

            paragraph1:
                "Helpline for Candidates Facing Difficulties Regarding Admit Cards",

            paragraph2:
                "IBPS link and helpline numbers for candidates facing difficulties while downloading their call letters",

            linktitle: "Link",
            link: "https://cgrs.ibps.in/",

            numbertitle: "Helpline Number",
            number: "1800 222 366 / 1800 103 4566",

            linktitle1: "Link for Downloading Admit Card",
            link1:
                "https://ibpsonline.ibps.in/dambcdjun23/oecla_nov23/downloadClose.php",

            linktitle2:
                "Link for Updating SEBC Category for Open Category Candidates",
            link2: "https://ibpsonline.ibps.in/dambcdjun23/",

            linktitle3: "Click here to fill out the form",
            link3:
                "https://ibpsonline.ibps.in/dambcdjun23/",

            download: {
                title: "Download",
                information: "Information Booklet",
                selection: "Selection List",
                marks: "Candidates Marks List",
                advertisement: "Advertisement & Press Release",
            },
        },

        मराठी: {
            title: "भरती",
            breadcrumb: {
                home: "मुख्यपृष्ठ",
                page: "भरती",
            },

            paragraph:
                "मार्गदर्शक व्याख्याता पद रद्द करणेबाबत नोटीस",

            paragraph1:
                "उमेदवारांना प्रवेशपत्रासंबंधित अडचणीत असल्यास हेल्पलाईन",

            paragraph2:
                "उमेदवारांना कॉल लेटर डाउनलोड करण्यासाठी येणाऱ्या समस्यांसाठी IBPS ची लिंक व हेल्प लाईन नंबर्स",

            linktitle: "लिंक",
            link: "https://cgrs.ibps.in/",

            numbertitle: "हेल्पलाईन नंबर",
            number: "1800 222 366 / 1800 103 4566",

            linktitle1: "प्रवेश पत्र डाउनलोड करण्यासाठी लिंक",
            link1:
                "https://ibpsonline.ibps.in/dambcdjun23/oecla_nov23/downloadClose.php",

            linktitle2:
                "खुल्या प्रवर्गातील उमेदवारांसाठी SEBC प्रवर्ग अद्ययावत करण्यासाठी लिंक",
            link2: "https://ibpsonline.ibps.in/dambcdjun23/",

            linktitle3: "फॉर्म भरण्यासाठी क्लिक करा",
            link3:
                "https://ibpsonline.ibps.in/dambcdjun23/",

            download: {
                title: "डाउनलोड करा",
                information: "माहिती पुस्तिका",
                selection: "निवड यादी",
                marks: "उमेदवारची गुणांनुक्रमे यादी",
                advertisement: "जाहिरात व प्रसिद्धीपत्रके",
            },
        },
    };

    const t = content[selectedLang] || content.English;

    return (
        <div className="bg-[#F6F6EC] min-h-screen px-4 py-16">
            {/* Page Title and Breadcrumb */}
            <div className="text-center mb-8">
                <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
                    {t.title}
                </h1>

                <p className="font-futura tracking-wider uppercase text-sm sm:text-base lg:text-[15px] font-medium mt-2">
                    <span style={{ color: "#DD9827" }}>
                        <Link to="/" className="hover:underline">
                            {t.breadcrumb.home}
                        </Link>{" "}
                        /{" "}
                    </span>
                    {t.breadcrumb.page}
                </p>
            </div>

            {/* Recruitment Content */}
            <div className="max-w-7xl mx-auto px-2 sm:px-6 md:px-12 lg:px-20 text-justify text-black space-y-4 mt-12 font-futura">

                {/* Notice */}
                <p className="text-[14px] font-bold sm:text-lg md:text-xl lg:text-[17px] leading-[1.5rem]">
                    {t.paragraph}
                </p>

                {/* Helpline Heading */}
                <p className="text-[14px] font-semibold sm:text-lg md:text-xl lg:text-[17px] leading-[1.5rem]">
                    {t.paragraph1}
                </p>

                <div className="space-y-1">
                    {/* Description */}
                    <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.5rem]">
                        {t.paragraph2}
                    </p>

                    {/* IBPS Link */}
                    <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.5rem]">
                        {t.linktitle}:{" "}
                        <a
                            href={t.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 hover:underline"
                        >
                            {t.link}
                        </a>
                    </p>

                    {/* Helpline Number */}
                    <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.5rem]">
                        {t.numbertitle}: {t.number}
                    </p>
                </div>

                {/* Admit Card Link */}
                <p className="text-[16px] sm:text-lg md:text-xl lg:text-[18px] leading-[1.5rem] font-bold">
                    <a
                        href={t.link1}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline animate-pulse"
                    >
                        {t.linktitle1}
                    </a>
                </p>

                {/* SEBC Update Link */}
                <p className="text-[16px] sm:text-lg md:text-xl lg:text-[20px] leading-[1.5rem] font-bold">
                    <a
                        href={t.link2}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline animate-pulse"
                    >
                        {t.linktitle2}
                    </a>
                </p>

                {/* Download Section */}
                <div className="mt-6">
                    <p className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.5rem] font-semibold mb-2">
                        {t.download.title}
                    </p>


                    {/* =========================================================
    INFORMATION BOOKLET
========================================================= */}
                    <div className="border border-gray-200">
                        <button
                            type="button"
                            onClick={() =>
                                setOpenDownload(
                                    openDownload === "information"
                                        ? null
                                        : "information"
                                )
                            }
                            className="w-full flex items-center gap-3 bg-gray-100 px-3 py-2 text-left hover:bg-gray-200"
                        >
                            <span className="text-xl font-bold text-[#DD164E]">
                                {openDownload === "information" ? "−" : "+"}
                            </span>

                            <span className="text-[14px] sm:text-base font-medium text-black">
                                {t.download.information}
                            </span>
                        </button>

                        {openDownload === "information" && (
                            <div className="bg-white px-4 py-3 space-y-2">
                                {informationBooklets.map((item, index) => (
                                    <a
                                        key={index}
                                        href={item.pdf}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block text-blue-600 hover:underline text-[14px] sm:text-base"
                                    >
                                        <div className="flex items-center gap-2">
                                            <FaFilePdf className="text-red-600 flex-shrink-0" />

                                            <span>
                                                {selectedLang === "मराठी"
                                                    ? item.marathi
                                                    : item.english}
                                            </span>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>


                    {/* Selection List */}
                    <div className="border border-gray-200 mt-2">
                        <button
                            type="button"
                            onClick={() =>
                                setOpenDownload(
                                    openDownload === "selection"
                                        ? null
                                        : "selection"
                                )
                            }
                            className="w-full flex items-center gap-3 bg-gray-100 px-3 py-2 text-left hover:bg-gray-200"
                        >
                            <span className="text-xl font-bold text-[#DD164E]">
                                {openDownload === "selection" ? "−" : "+"}
                            </span>

                            <span className="text-[14px] sm:text-base font-medium text-black">
                                {t.download.selection}
                            </span>
                        </button>

                        {openDownload === "selection" && (
                            <div className="bg-white px-4 py-3 space-y-2">
                                {selectionLists.map((item, index) => (
                                    <a
                                        key={index}
                                        href={item.pdf}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block text-blue-600 hover:underline text-[14px] sm:text-base"
                                    >
                                        <div className="flex items-center gap-2">
                                            <FaFilePdf className="text-red-600 flex-shrink-0" />

                                            <span>
                                                {selectedLang === "मराठी"
                                                    ? item.marathi
                                                    : item.english}
                                            </span>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Candidates Marks List */}
                    <div className="border border-gray-200 mt-2">
                        <button
                            type="button"
                            onClick={() =>
                                setOpenDownload(
                                    openDownload === "marks"
                                        ? null
                                        : "marks"
                                )
                            }
                            className="w-full flex items-center gap-3 bg-gray-100 px-3 py-2 text-left hover:bg-gray-200"
                        >
                            <span className="text-xl font-bold text-[#DD164E]">
                                {openDownload === "marks" ? "−" : "+"}
                            </span>

                            <span className="text-[14px] sm:text-base font-medium text-black">
                                {t.download.marks}
                            </span>
                        </button>

                        {openDownload === "marks" && (
                            <div className="bg-white px-4 py-3 space-y-2">
                                {marksLists.map((item, index) => (
                                    <a
                                        key={index}
                                        href={item.pdf}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block text-blue-600 hover:underline text-[14px] sm:text-base"
                                    >
                                        <div className="flex items-center gap-2">
                                            <FaFilePdf className="text-red-600 flex-shrink-0" />

                                            <span>
                                                {selectedLang === "मराठी"
                                                    ? item.marathi
                                                    : item.english}
                                            </span>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Advertisement & Press Release */}
                    <div className="border border-gray-200 mt-2">
                        <button
                            type="button"
                            onClick={() =>
                                setOpenDownload(
                                    openDownload === "advertisement"
                                        ? null
                                        : "advertisement"
                                )
                            }
                            className="w-full flex items-center gap-3 bg-gray-100 px-3 py-2 text-left hover:bg-gray-200"
                        >
                            <span className="text-xl font-bold text-[#DD164E]">
                                {openDownload === "advertisement" ? "−" : "+"}
                            </span>

                            <span className="text-[14px] sm:text-base font-medium text-black">
                                {t.download.advertisement}
                            </span>
                        </button>

                        {openDownload === "advertisement" && (
                            <div className="bg-white px-4 py-3 space-y-2">
                                {advertisementLists.map((item, index) => (
                                    <a
                                        key={index}
                                        href={item.pdf}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block text-blue-600 hover:underline text-[14px] sm:text-base"
                                    >
                                        <div className="flex items-center gap-2">
                                            <FaFilePdf className="text-red-600 flex-shrink-0" />

                                            <span>
                                                {selectedLang === "मराठी"
                                                    ? item.marathi
                                                    : item.english}
                                            </span>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <p className="text-[16px] sm:text-lg md:text-xl lg:text-[18px] leading-[1.5rem] font-bold">
                    <a
                        href={t.link3}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline animate-pulse"
                    >
                        {t.linktitle3}
                    </a>
                </p>
            </div>
        </div>
    );
};

export default Recruitment;
